<template>
    <div class="snapmodal">
        <div id="timelineSnap" v-if="post" class="cardChild">
            <PostCardComponent :post="post" />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, watch, nextTick } from 'vue'
import PostCardComponent from './PostCardComponent.vue'
import firebaseService from "@/services/firebase.service"
import domtoimage from 'dom-to-image'
import { popModal } from "jenesius-vue-modal"
import { useCreatePost } from "../../composables/createpost.composable"

const props = defineProps({
    post: {
        type: Object,
        default: () => ({})
    }
})
const dismiss = () => popModal()
const { feedSnap, addPostAfterSnap, createPotStockRes } = useCreatePost()
const loader = ref( false )
const getImages = async () => {
    const key = 'timelineSnap'
    const doc = document.getElementById( 'timelineSnap' )
    if ( doc ) {
        try {
            const blob = await domtoimage.toJpeg( doc, { quality: 1.0 } )
            feedSnap.value = await firebaseService.uploadBase64ImageForTimeLine( blob, props.post._id, props.post.userId, key )
            if ( feedSnap.value ) {
                addPostAfterSnap()
                popModal()
            }
        } catch ( error ) {
            console.error( "Error generating or uploading image:", error )
        }
    }
}

onMounted( () => {
    const modals = document.querySelectorAll( '.widget__modal-container__item.modal-container' )
    if ( modals.length > 1 ) {
        modals[1].style.zIndex = 'auto' // Apply z-index: auto to the second one
    }
    nextTick( () => {
        setTimeout( () => {
            getImages()
        }, 500 )
    } )
} )
</script>
<style lang="scss">
:deep(.widget__modal-container__item) {
    z-index: 0 !important;
    background: #d12;
}

:deep(.modal-container) {
    z-index: 0 !important;
}

.snapmodal {
    .cardChild {
        width: 600px;
    }
}
</style>